import { useState } from "react";
import { appPlatforms } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function AppDownload() {
  const [activeKey, setActiveKey] = useState(appPlatforms[0].key);
  const active = appPlatforms.find((p) => p.key === activeKey) ?? appPlatforms[0];

  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/60">
      <Reveal>
        <SectionHeading
          tag="APP 下载"
          title="APP 下载方式与安全提醒"
          desc="安装包只从官方渠道或正规应用商店获取。下面按系统分别说明下载与安装时需要注意的细节。"
        />
      </Reveal>

      <Reveal delay={60}>
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-2">
              <div className="flex gap-1.5 p-1">
                {appPlatforms.map((p) => (
                  <button
                    key={p.key}
                    onClick={() => setActiveKey(p.key)}
                    aria-selected={activeKey === p.key}
                    className={`flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2.5 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                      activeKey === p.key
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-600 hover:bg-background-100"
                    }`}
                  >
                    <i className={`${p.icon} text-base`}></i>
                    {p.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="mt-4 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <h3 className="font-heading font-bold text-secondary-900 text-base flex items-center gap-2">
                <i className="ri-error-warning-line"></i>
                下载前的底线
              </h3>
              <p className="mt-2 text-sm text-secondary-900/90 leading-relaxed">
                任何要求支付密码、银行卡信息或短信验证码的「下载引导」都应当拒绝。
                安装包只从官方渠道或正规应用商店获取，不为图快而使用第三方下载站。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2.5">
                <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${active.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading font-bold text-foreground-950 text-lg">
                    {active.label} · 操作要点
                  </h3>
                  <p className="text-xs text-foreground-500 font-label">{active.points.length} 条注意事项</p>
                </div>
              </div>
              <ul className="mt-5 space-y-3.5">
                {active.points.map((text, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-md bg-background-100 text-primary-700 flex items-center justify-center text-xs font-label shrink-0 mt-0.5">
                      {idx + 1}
                    </span>
                    <span className="text-sm text-foreground-700 leading-relaxed">{text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}